import { List, Create, Edit, Home } from "../Components/index.js";

export default [
    {
        path: "/fd/dashboard/home/list",
        component: () => import("@/App/FD/Dashboard/Components/Home.vue"),
        name: "fd.dashboard.home.list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/fd/Dining-members/list",
        component: () => import("@/App/FD/Dashboard/Components/DiningMembers.vue"),
        name: "fd.dashboard.list",
        meta: {
            requiresAuth: true,
        },
    },
];
